import React from 'react';
import { SellerBadgesType } from '@interfaces/models/seller-info/seller-information';
import Icon from '@components/atoms/icon/icon';
import Badge, { BadgeType } from '@components/common/badge/badge';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import styles from './seller-badges.module.scss';

interface SellerBadgesProps {
  badges: SellerBadgesType[];
  badgeType?: BadgeType;
  onBadgeClick: (bagdeName: string) => void;
  trackConsignmentClick?: (e) => void;
}

const SellerBadges: React.FC<SellerBadgesProps> = (props) => {
  const { badges, onBadgeClick, trackConsignmentClick } = props;
  const { t } = useTranslation();

  const badgeContent = {
    'fashion-activist': {
      title: t('PRODUCT.DESCRIPTION.FASHION_ACTIVIST'),
      icon: 'badge-fashion-activist',
      className: '',
      link: '/journal/fashion-activist-badge',
      datacy: 'fashion-activist-badge',
    },
    'trusted-seller': {
      title: t('PRODUCT.DESCRIPTION.TRUSTED_SELLER'),
      icon: 'badge-trusted',
      className: 'vc-badge--trusted',
      link: '/seller-badges',
      datacy: 'trusted-seller-badge',
    },
    'expert-seller': {
      title: t('PRODUCT.DESCRIPTION.EXPERT_SELLER'),
      icon: 'badge-expert',
      className: 'vc-badge--expert',
      link: '/seller-badges',
      datacy: 'expert-seller-badge',
    },
    'official-store': {
      title: t('PRODUCT.DESCRIPTION.BRAND_STORE'),
      className: 'vc-badge--official-store',
      link: '/journal/raas-brand-partner-x-vestiaire-collective/',
      datacy: 'official-store-badge',
    },
  };

  return (
    <>
      {badges?.map((badge) => {
        return (
          <React.Fragment key={badge}>
            {badgeContent[badge] && (
              <a
                onClick={(e) => {
                  onBadgeClick(badgeContent[badge]?.title);
                  if (badge === 'official-store' && !!trackConsignmentClick) {
                    trackConsignmentClick?.(e);
                  }
                }}
                href={badgeContent[badge]?.link}
                rel="noreferrer noopener"
                className={styles.sellerBadge}
                data-cy={badgeContent[badge]?.datacy}
              >
                <Badge
                  type={'default'}
                  className={clsx(
                    'vc-badge vc-badge--small',
                    badgeContent[badge]?.className,
                    badge !== 'official-store' && styles['vc-badge'],
                  )}
                  badgeSize="small"
                  isInteractive={false}
                >
                  {badgeContent[badge]?.icon && (
                    <Icon
                      name={badgeContent[badge]?.icon}
                      className={clsx('icon', styles.sellerBadge__icon)}
                      ariaHidden
                    />
                  )}
                  <span>{badgeContent[badge]?.title}</span>
                </Badge>
              </a>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default SellerBadges;
